import type { CSSProperties, KeyboardEvent, UIEventHandler } from 'react';
import type { ColorType } from '@/theme/colors';

export enum TextInputMode {
  Textual = 'textual',
  Dropdown = 'dropdown',
}

export type CtextinputElement = HTMLInputElement | HTMLTextAreaElement;

export interface CtextinputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  /** HTML id attribute for the input element (for form accessibility) */
  id?: string;
  /** HTML name attribute for the input element (for form submission) */
  name?: string;
  rows?: number;
  errorText?: string;
  /** Force error styling (danger border) without showing error text */
  isError?: boolean;
  disabled?: boolean;
  mode?: TextInputMode;
  availableOptions?: string[];
  radius?: number;
  paddingRight?: number;
  padding?: string;
  backgroundColor?: ColorType;
  backgroundOpacity?: number;
  borderColor?: ColorType;
  borderOpacity?: number;
  borderWidth?: number;
  innerBorder?: boolean;
  boxShadow?: string;
  height?: number;
  textAlign?: 'left' | 'center' | 'right';
  fontSize?: number;
  inputContentStyle?: CSSProperties;
  /** Style merged onto the `<input>` / `<textarea>` ELEMENT itself.
   *
   *  It exists for one thing `inputContentStyle` cannot reach: the element is
   *  the SCROLLPORT of a multi-line field, so any breathing room a design wants
   *  the text to scroll UNDER has to be padding on this element. Put it on the
   *  wrapper instead and the text stops a whole gutter short of the box, which
   *  reads as a dead band under a faded last line. */
  inputElementStyle?: CSSProperties;
  /** Automatically focus the input on mount */
  autoFocus?: boolean;
  /** Optional callback when text input receives focus */
  onFocus?: () => void;
  /** Optional callback when text input loses focus */
  onBlur?: () => void;
  onKeyDown?: (event: KeyboardEvent<CtextinputElement>) => void;
  onScroll?: UIEventHandler<CtextinputElement>;
  className?: string;
  style?: CSSProperties;
}
